import { HorizontalBar, mixins } from 'vue-chartjs'
import { $t, i18next } from '../i18n'

const { reactiveProp } = mixins

export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: ['chartData'],
  data () {
    return {
      options: {
        indexAxis: 'y',
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: this.$t('contacts.activityDistributionPortals')
            },
            barThickness: 35, // number (pixels) or 'flex'
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: false
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: this.$t('contacts.contactGenere')
            },
            ticks: {
              beginAtZero: true,
              steps: 10,
              stepValue: 5
            },
            gridLines: {
              display: true
            }
          }]
        },
        legend: {
          display: false
        },
        tooltips: {
          enabled: false
          // mode: 'single',
          // callbacks: {
          //     label: function(tooltipItems, data) {
          //         return tooltipItems.xLabel;
          //     }
          // }
        },
        hover: {
          animationDuration: 1
        },
        animation: {
          duration: 1,
          onComplete: function () {
            const ctx = this.chart.ctx
            ctx.textAlign = 'center'
            ctx.textBaseline = 'bottom'

            this.data.datasets.forEach(function (dataset) {
              for (let i = 0; i < dataset.data.length; i++) {
                const model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model
                const scale_max = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._xScale.maxHeight
                ctx.fillStyle = 'white'

                let x_pos = model.x - 15
                if ((scale_max - model.x) >= 0.93) {
                  ctx.fillStyle = 'grey'
                  x_pos = model.x + 20
                }
                ctx.fillText(dataset.data[i], x_pos, model.y + 5)
              }
            })
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}
